// export default function UpdateCourse() {
//   return <div>UpdateCourse</div>;
// }

import { useEffect, useRef } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { Button, Grid, Paper } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { useHistory, useLocation } from "react-router-dom";

import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import { TypographyHeading } from "shared/molecules/typography-layout";
import { snackbarRequest } from "shared/molecules/snackbar/snackbar-slice";

import useReactHookForm from "hooks/useReactHookForm";
import { useAppDispatch } from "hooks/redux";

import entitesClient from "utils/graphql/entitiesClient";
import { GET_COURSES_LIST } from "utils/graphql/services/global-content-hierarchy/queries";
import { UPDATE_COURSE } from "utils/graphql/services/global-content-hierarchy/mutation";
import { getQueryParam, isEmpty } from "utils/helpers";

import {
  courseInitialValues,
  courseMandatoryFields,
  
  courseValidationSchema,
  
  createCourseProperties,
  previewCourseProperties
} from "./helper";
import { isFieldsValidate } from "shared/organisms/dynamicform/helper";

export const UpdateCourse = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const courseId = getQueryParam("id", location);
  const status = getQueryParam("status", location);

  const { control, errors, getValues, setValue, watch } = useReactHookForm(
    courseInitialValues,
    courseValidationSchema,
    ""
  );

   // Ref to store the original course name
  // const originalCourseName = useRef<string>("");

  // Queries
  const [getCourses, { loading, data }] = useLazyQuery(GET_COURSES_LIST, {
    client: entitesClient,
  });

  // Mutation
  const [updateCourse, { loading: loadingUp }] = useMutation(UPDATE_COURSE, {
    client: entitesClient,
  });

  // Fetch course details
  useEffect(() => {
    if (courseId) {
      getCourses({
        variables: {
          filter: { id: Number(courseId),status },
        },
      });
    }
  }, [courseId]);

  // Populate values when data arrives
  useEffect(() => {
    if (data?.getCourses?.records?.[0]) {
      const course = data.getCourses.records[0];
      setValue("course_name", course.course_name || "");
      setValue("gcf_public_course_id", course.gcf_public_course_id || "");
      // originalCourseName.current = course.course_name || "";

      // set the other field values
      setValue("npractice_practice_program_id", course.npractice_practice_program_id || "");
      setValue("display_name", course.display_name || "");
      setValue("status", course.status || "");
      setValue("image_url", course.image_url || "");
    }
  }, [data]);

  // Determine if any changes have been made
  // const isChanged = watch("course_name") !== originalCourseName.current;

  // Update handler
  const handleUpdateCourse = async () => {
    try {
      const response: any = await updateCourse({
        variables: {
          input: {
            id: Number(courseId),
            course_name: watch("course_name"),
            gcf_public_course_id: watch("gcf_public_course_id"),
            // pass new fields payload
            npractice_practice_program_id: watch("npractice_practice_program_id"),
            display_name: watch("display_name"),
            image_url: watch("image_url"),
            status: watch("status"),
          },
        },
      });

      if (response?.data?.updateCourse?.success) {
        dispatch(
          snackbarRequest({ message: "Course updated successfully!" })
        );
        history.replace("/global-content-hierarchy/courses");
      } else {
        dispatch(
          snackbarRequest({
            message:
              response?.data?.updateCourse?.message || "Failed to update course",
            type: "error",
          })
        );
      }
    } catch (err) {
      dispatch(snackbarRequest({ message: `${err}`, type: "error" }));
    }
  };

  if (loading) return <p>Loading course...</p>;

  return (
    <div>
      <TypographyHeading>Course</TypographyHeading>
      <Paper elevation={2} sx={{ px: 2, pb: 2, pt: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={previewCourseProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
        </Grid>
      </Paper>
    </div>
  );
};
